import React, { Component } from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { RichText } from 'prismic-reactjs'

import IconData from '../IconData'

import './style.css'

class VetsView extends Component {
  render() {
    return (
      <div className="Vets">
        <div className="mid">
          <Grid>
            <Row>
              {this.props.vets.map(v => (
                <Col xs={12} lg={4} key={v.id}>
                  <div className="vet">
                    <div
                      className="avatar"
                      style={{ backgroundImage: `url('${v.kep.url}')` }}
                    />
                    <div className="name">{v.nev}</div>
                    <div className="description">{v.leiras}</div>
                    <div className="times">
                      {RichText.render(v['rendelesi-ido'])}
                    </div>
                    <div className="actions">
                      <IconData name="mobile" fullWidth>
                        <a href={`tel:${v.mobil}`}>{v.mobil}</a>
                      </IconData>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Grid>
        </div>
      </div>
    )
  }
}

export default VetsView



// WEBPACK FOOTER //
// ./src/components/Vets/VetsView.js